import React, { useEffect, useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DashboardLayout from './DashboardLayout';
import MembershipsManagement from './Memberships/MembershipsManagement';
import baseURL from '../../user/config';
import PageLoader from '../../../Reusable/PageLoader';

const Memberships = () => {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchForms = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${baseURL}/org/membership-forms`, {
                method: 'GET',
                credentials: 'include',
            });
            if (!response.ok) throw new Error('Failed to fetch membership forms.');
            const data = await response.json();
            setForms(data.forms);
        } catch (err) {
            toast.error(`Error fetching membership forms: ${err.message}`);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchForms();
    }, [fetchForms]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />}
            {!loading && (
                <Box sx={{ p: 1 }}>
                    <MembershipsManagement forms={forms} refetchForms={fetchForms} />
                </Box>
            )}
        </DashboardLayout>
    );
};

export default Memberships;
